import { VISIBLE_STATE } from "./StateConstants.ts";


export interface SpeakerModel {
  objectId?: string
  createdAt?: Date
  updatedAt?: Date
  avatar?: string
  firstName?: string
  lastName?: string
  bio?: string
  abbreviatedBio?: string
  hidden?: boolean
  hiddenState: string
  occupation?: string
  sortOrder?: number
}


export class Speaker implements SpeakerModel {
  objectId?: string
  createdAt?: Date
  updatedAt?: Date
  avatar?: string
  firstName?: string
  lastName?: string
  bio?: string
  abbreviatedBio?: string
  hidden?: boolean
  hiddenState: string
  occupation?: string
  sortOrder?: number

  constructor(
    objectId = undefined,
    createdAt = undefined,
    updatedAt = undefined,
    avatar = undefined,
    firstName = undefined,
    lastName = undefined,
    bio = undefined,
    abbreviatedBio = undefined,
    hidden = undefined,
    hiddenState = "",
    occupation = undefined,
    sortOrder = undefined
  ) {
    this.objectId = objectId
    this.createdAt = createdAt
    this.updatedAt = updatedAt
    this.avatar = avatar
    this.firstName = firstName
    this.lastName = lastName
    this.bio = bio
    this.abbreviatedBio = abbreviatedBio
    this.hidden = hidden
    this.hiddenState = hiddenState
    this.occupation = occupation
    this.sortOrder = sortOrder
  }

  static convertFromParseObject(parseObject: any): SpeakerModel {
    const hiddenState = parseObject?.get("hidden") ? VISIBLE_STATE.PRIVATE : VISIBLE_STATE.PUBLIC

    return new Speaker(
      parseObject?.id,
      parseObject?.createdAt,
      parseObject?.updatedAt,
      parseObject?.get("avatar")?.url(),
      parseObject?.get("firstName"),
      parseObject?.get("lastName"),
      parseObject?.get("bio"),
      parseObject?.get("abbreviatedBio"),
      parseObject?.get("hidden"),
      hiddenState,
      parseObject?.get("occupation"),
      parseObject?.get("sortOrder")
    )
  }
}
